export default {
    en: {
        week: "Week",
        month: "Month",
        year: "Year",
        byName: "Popular product by names",
        byColor: "Popular by colors",
        byDimension: "Popular by dimensions",
        unPopular: "Unpopular product names"
    },
    uz: {
        week: "Haftalik",
        month: "Oylik",
        year: "Yillik",
        byName: "Nomlar bo'yicha mashhur",
        byColor: "Ranglar bo'yicha mashhur",
        byDimension: "O'lchami bo'yicha mashhur",
        unPopular: "Mashhur bo'lmagan mahsulotlar"
    },
    ru: {
        week: "Неделю",
        month: "Месяц",
        year: "Год",
        byName: "Популярный продукт по именам",
        byColor: "Популярные по цветам",
        byDimension: "Популярный по размерам",
        unPopular: "Непопулярные названия продуктов"
    },
}